function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3366"
    },
    d: "M113,123H16c-6.6000004,0-12-5.4000015-12-12V97c0-6.5999985,5.3999996-12,12-12h97 c6.5999985,0,12,5.4000015,12,12v14C125,117.5999985,119.5999985,123,113,123z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 92.3391418,
    style: {
      fill: "none"
    },
    width: 109,
    height: 28.6608582
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.4023438 115.1386719)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'OpenSans-Bold'",
      fontSize: 30
    }
  }, "FINISH"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.d9dab3bbd5768ae427f55c9718ce5498.svg";
export { ForwardRef as ReactComponent };